<template>
  <div class="margin-top">
    <el-alert v-if="ownerDetailAccessControlInfo.statusText"
      :title="ownerDetailAccessControlInfo.statusText"
      :type="ownerDetailAccessControlInfo.statusType"
      :closable="false"
      show-icon
      class="margin-bottom">
    </el-alert>
    <el-table
      :data="ownerDetailAccessControlInfo.machineTranslates"
      style="width: 100%"
      border
      stripe
    >
      <el-table-column prop="typeCdName" :label="$t('ownerDetailAccessControl.objectType')" align="center"></el-table-column>
      <el-table-column prop="objName" :label="$t('ownerDetailAccessControl.objectName')" align="center"></el-table-column>
      <el-table-column prop="machineCmdName" :label="$t('ownerDetailAccessControl.command')" align="center"></el-table-column>
      <el-table-column prop="stateName" :label="$t('ownerDetailAccessControl.status')" align="center"></el-table-column>
      <el-table-column :label="$t('ownerDetailAccessControl.description')" align="center">
        <template slot-scope="scope">
          <div class="hc-td">{{scope.row.remark}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="updateTime" :label="$t('ownerDetailAccessControl.syncTime')" align="center"></el-table-column>
      <el-table-column :label="$t('ownerDetailAccessControl.operation')" align="center">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.state === '1300' || scope.row.state === '1400'"
            type="text"
            size="small"
            @click="_openEditMachineTranslateModel(scope.row)"
          >
            {{$t('ownerDetailAccessControl.resync')}}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row>
      <el-col :span="4"></el-col>
      <el-col :span="20">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { queryPcOwnerFaceDetail } from '@/api/owner/isupOwnerFaceApi'
import { retryPersonDeviceSync } from '@/api/machine/isupPersonFaceApi'
import { getCommunityId } from '@/api/community/communityApi'

export default {
  name: 'OwnerDetailAccessControl',
  data() {
    return {
      ownerDetailAccessControlInfo: {
        machineTranslates: [],
        ownerId: '',
        statusText: '',
        statusType: 'info'
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      communityId: ''
    }
  },
  created() {
    this.communityId = getCommunityId()
  },
  methods: {
    open(ownerId) {
      this.ownerDetailAccessControlInfo.ownerId = ownerId
      this._loadOwnerDetailAccessControlData(this.currentPage, this.pageSize)
    },
    async _loadOwnerDetailAccessControlData(page, row) {
      const param = {
        page: page,
        row: row,
        communityId: this.communityId,
        personId: this.ownerDetailAccessControlInfo.ownerId
      }

      try {
        const response = await queryPcOwnerFaceDetail(param)
        this.ownerDetailAccessControlInfo.machineTranslates = response.machineTranslates
        this.ownerDetailAccessControlInfo.statusText = response.message || ''
        this.ownerDetailAccessControlInfo.statusType = response.overallState === 'SUCCESS'
          ? 'success' : (response.overallState === 'FAILED' ? 'error' : 'info')
        this.total = response.total
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    async _openEditMachineTranslateModel(machineTranslate) {
      try {
        await retryPersonDeviceSync({ syncId: machineTranslate.syncId })
        this.$message.success('已重新进入待同步')
        this._loadOwnerDetailAccessControlData(this.currentPage, this.pageSize)
      } catch (error) {
        this.$message.error(error.message || '重试失败')
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._loadOwnerDetailAccessControlData(val, this.pageSize)
    }
  }
}
</script>

<style scoped>
.margin-bottom {
  margin-bottom: 12px;
}
</style>
